/**
 * PROJECTS PAGE - FLO SIGNATURE DESIGN SYSTEM v2
 * Clean. Controlled. Consistent. Dark tool mode.
 */

import React, { useState } from 'react';
import { PlusIcon } from '@heroicons/react/24/outline';
import { Screen, Section, Button } from '../design/primitives';
import ProjectList from '../components/ProjectList';
import ProjectForm from '../components/forms/ProjectForm';

const Projects: React.FC = () => {
  const [isProjectFormOpen, setIsProjectFormOpen] = useState(false);

  return (
    <Screen>
      <Section
        title="Projects"
        action={
          <Button
            variant="primary"
            onClick={() => setIsProjectFormOpen(true)}
            icon={<PlusIcon style={{ width: '16px', height: '16px' }} />}
          >
            New Project
          </Button>
        }
      >
        <ProjectList />
      </Section>

      <ProjectForm
        isOpen={isProjectFormOpen}
        onClose={() => setIsProjectFormOpen(false)}
      />
    </Screen>
  );
};

export default Projects;
